import React from 'react';

import { Checkbox } from '@buildoutinc/blueprint-react/ui/Checkbox';
import { Input } from '@buildoutinc/blueprint-react/ui/Input';
import { Select } from '@buildoutinc/blueprint-react/ui/Select';
import { faImage, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'components/ui/button';

interface MediaTypeOption {
  label: string,
  value: string
}

interface Embed {
  embedUrl: string,
  fetchThumbnailUrl?: string,
  mediaType: string
}

interface Props {
  embed: Embed,
  index: number,
  isSelected: boolean,
  mediaTypeOptions: MediaTypeOption[],
  onChange: (column: 'embedUrl' | 'mediaType', value: string) => void,
  onDelete: () => void,
  onSelect: () => void
}

export default function OsEmbedRow({
  embed, index, isSelected, mediaTypeOptions, onChange, onDelete, onSelect,
}: Props) {
  const number = index + 1;

  return (
    <div className="visual-media-row d-flex align-items-center gap-2">
      <Checkbox aria-label={`Select visual media ${number}`} checked={isSelected} onCheckedChange={onSelect} />
      {embed.fetchThumbnailUrl ? (
        <img alt="" className="visual-media-thumbnail rounded border" loading="lazy" src={embed.fetchThumbnailUrl} />
      ) : (
        <div
          className="visual-media-thumbnail rounded border d-flex align-items-center justify-content-center text-muted"
        >
          <FontAwesomeIcon icon={faImage} />
        </div>
      )}
      <div className="visual-media-type">
        <Select
          items={mediaTypeOptions}
          value={embed.mediaType}
          onValueChange={(value: string) => onChange('mediaType', value)}
        >
          <Select.Trigger aria-label={`Media type ${number}`}>
            <Select.Value />
          </Select.Trigger>
          <Select.Content>
            {mediaTypeOptions.map(option => (
              <Select.Item key={option.value} value={option.value}>{option.label}</Select.Item>
            ))}
          </Select.Content>
        </Select>
      </div>
      <div className="flex-grow-1">
        <Input
          aria-label={`Embed URL ${number}`}
          placeholder="https://"
          value={embed.embedUrl}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange('embedUrl', e.target.value)}
        />
      </div>
      <Button
        aria-label={`Remove visual media ${number}`}
        icon={faTrashCan}
        tooltip="Remove"
        type="button"
        variant="ghost"
        onClick={onDelete}
      />
    </div>
  );
}
